<template>
    <section class="w-screen h-screen absolute flex justify-center items-center z-50">
        <div id="modal modal-customer" class="modal absolute block w-5/6  bg-white shadow-md rounded-lg" :class="{
            'animate__animated animate__zoomIn': showModal,
            'animate__animated animate__zoomOut': !showModal,
        }">
            <div id="modal-header" class="w-full bg-color-1 py-3 rounded-t-lg">
                <h5 class="text-white text-center font-bold text-xl">Filter Transaksi</h5>
            </div>
            <div id="modal-body"
                class="p-5 max-h-[calc(100dvh-220px)] overflow-y-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <div class="flex flex-col gap-2">
                    <label class="font-medium text-dark-600 dark:text-dark-400">Range Tanggal</label>
                    <DatePicker v-model="rangeDate" selectionMode="range" :manualInput="false" />
                </div>
                <InputSelect v-model="selectedType" label="Tipe Order" id="filter-status" :options="allTypes"
                    placeholder="Pilih tipe order" optionLabel="name" optionValue="id" />
                <InputTextCustom v-model="selectedCustomer" label="Pelanggan" id="filter-customer"
                    placeholder="Pilih pelanggan" :valid="validation.name.valid" :error-message="validation.name.message" />
                <InputSelect v-model="selectedTableId" label="Meja" id="filter-meja" :options="allTables"
                    placeholder="Pilih meja" optionLabel="name" optionValue="id" :is-scrolled="allTables.length > 20"
                    :virtual-scroller-options="{ itemSize: 38 }" />
                <InputSelect v-model="selectedMarketingId" label="Penanggung Jawab" id="filter-marketing"
                    :options="allMarketings" placeholder="Pilih penanggung jawab" optionLabel="name" optionValue="id"
                    :virtual-scroller-options="{ itemSize: 38 }" :is-scrolled="allMarketings.length > 10" />
                <InputSelect v-model="selectedCashRegisterId" label="Cash Register" id="filter-cash-register"
                    :options="optionCashRegister" placeholder="Pilih cash register" optionLabel="name"
                    optionValue="id" />
                <InputSelect v-model="selectedStatus" label="Status" id="filter-status" :options="allStatuses"
                    placeholder="Pilih status" optionLabel="name" optionValue="id" />
            </div>
            <div class="modal-footer p-5">
                <div class="flex justify-center">
                    <SubmitButton id="close" button_name="Close"
                        button_class="mx-1 text-red-600 border-red-600 hover:text-white hover:bg-red-600"
                        @click="closeModal" />
                    <SubmitButton id="submit" button_name="Filter"
                        button_class="mx-1 bg-color-1 hover:bg-color-2 text-color-4" @click="submitFilter" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import SubmitButton from '@/components/form/SubmitButton.vue';
    import { mapGetters } from 'vuex';
    import InputSelect from '@/components/form/InputSelect.vue';
    import { DatePicker } from 'primevue';
    import { formatTime } from '@/helpers/formatTime';
    import InputTextCustom from '@/components/form/InputTextCustom.vue';

    export default {
        name: "FilterCredit",
        props: {
            filter: {
                type: Object,
                default: null,
            },
            customerOption: {
                type: Array,
                default: () => [],
            },
        },
        components: {
            SubmitButton, InputSelect, DatePicker, InputTextCustom
        },
        computed: {
            ...mapGetters('marketings', ['allMarketings']),
            ...mapGetters('tables', ['allTables']),
            ...mapGetters('cash_registers', ['allCashRegisters']),
            ...mapGetters('payment_methods', ['allPaymentMethods']),
            optionCashRegister() {
                return this.allCashRegisters.map((item) => {
                    return {
                        name: `${formatTime(item.time_start)} - ${formatTime(item.time_end)}`,
                        id: item.id
                    }
                })
            }
        },
        async created() {
            try {
                // Fetch required data in parallel
                await Promise.all([
                    this.$store.dispatch("tables/fetchTables", { limit: 1000 }),
                    this.$store.dispatch("payment_methods/fetchPaymentMethods", { limit: 1000 }),
                    this.$store.dispatch("marketings/fetchMarketings", { limit: 1000 }),
                    this.$store.dispatch("cash_registers/fetchCashRegisters", { limit: 1000 }),
                ]);
                this.isLoading = false;
            } catch (error) {
                console.log(error);
                this.errorMessage =
                    error.message ||
                    "Terjadi kesalahan saat memuat data. Silakan coba lagi.";
                this.showErrorDialog = true;
                this.isLoading = false;
            }
        },
        data() {
            return {
                showModal: true,
                selectedType: '',
                rangeDate: null,
                allTypes: [
                    { id: 'dine_in', name: 'Dine In' },
                    { id: 'take_away', name: 'Take Away' },
                    { id: 'staff', name: 'Staff' },
                ],
                selectedStatus: '',
                allStatuses: [
                    { id: '1', name: 'Sudah Terbayar' },
                    { id: '0', name: 'Belum Terbayar' },
                ],
                filterCapacity: '',
                selectedTableId: '',
                selectedMarketingId: '',
                selectedCashRegisterId: '',
                selectedCustomer: '',
                validation: {
                    name: {
                        valid: true,
                        message: ''
                    },
                },
            }
        },
        methods: {
            formatTime,
            closeModal() {
                this.showModal = false;
                setTimeout(() => {
                    this.$emit('closeModal');
                }, 200);
            },
            submitFilter() {
                this.$emit('submitFilter', {
                    rangeDate: this.rangeDate,
                    type: this.selectedType,
                    status: this.selectedStatus,
                    table_id: this.selectedTableId,
                    marketing_id: this.selectedMarketingId,
                    cash_register_id: this.selectedCashRegisterId,
                    customer_name: this.selectedCustomer,
                });
                this.closeModal();
            }
        }
    }
</script>